import React from 'react';
import Link from 'react-router/Link';

import './Notifications.css';

const NotificationBanner = (props) => {

  const auth = props.auth;
  let message;

  if (!auth.user.onGenericTrial) {
    return <span></span>;
  }

  if (!auth.user.hasActiveSubscription && auth.user.onGenericTrial && props.subscriptions.info.untilTrialEnds) {
    message = <span>You have {props.subscriptions.info.untilTrialEnds} left of your trial period -&nbsp;<Link to='/account/subscription'> subscribe here </Link>&nbsp; to get access to Pronounce Live after that!</span>;
  }

  return (
    <div className="pronounce-notification-banner">
      {message}
    </div>
);

};

export default NotificationBanner;



// WEBPACK FOOTER //
// ./src/components/NotificationBanner.js